import React from "react";
import { Grid } from "@material-ui/core";
import Map from "./Map";
import StoreCategoriesFilter from "./StoreCategoriesFilter";
import NumberOfDirectCompetitors from "./NumberOfDirectCompetitors";
import NumberOfCompetitors from "./NumberOfCompetitors";
import NumberOfIndirectCompetitors from "./NumberOfIndirectCompetitors";
import AlternateCategoriesSwitch from "./AlternateCategoriesSwitch";
import SizeRelativeToDirectCompetitors from "./SizeRelativeToDirectCompetitors";

const NearbyCompetition = () => {
    return (
        <Grid container spacing={3} alignItems="center">
            <Grid item xs={'auto'}>
                <StoreCategoriesFilter />
            </Grid>
            <Grid item xs={6}>
                <AlternateCategoriesSwitch />
            </Grid>
            <Grid item xs={4}>
                <NumberOfDirectCompetitors />
            </Grid>
            <Grid item xs={4}>
                <NumberOfCompetitors />
            </Grid>
            <Grid item xs={4}>
                <NumberOfIndirectCompetitors />
            </Grid>
            <Grid item xs={12}>
                <Map />
            </Grid>
            <Grid item xs={12}>
                <SizeRelativeToDirectCompetitors />
            </Grid>
        </Grid>
    );
};

export default NearbyCompetition;
